import axiosClient from "../axiosClient";

export const getCourse = async () => {
    return await axiosClient.get('/course_all');
};

export const getInstructor = async () => {
    return await axiosClient.get('/get_instructor');
};

export const getCourseById = async (id) => {
    return await axiosClient.get(`/course_by_id/${id}`);
};

export const getCourseTags = async () => {
    return await axiosClient.get(`/get_course_tag_list`);
};

export const addCourse = async (data) => {
    return await axiosClient.post('/add_course', data);
};

export const editCourse = async (data) => {
    return await axiosClient.put('/edit_course', data);
};

export const deleteCourse = async (id) => {
    return await axiosClient.delete(`/delete_course/${id}`);
};

export const getCourseGroupDetails = async (id) => {
    return await axiosClient.get(`/get_course_group_details/${id}`);
};

export const getPostsDetail = async (id) => {
    return await axiosClient.get(`/get_admin_post/${id}`);
};

export const addPost = async (data) => {
    return await axiosClient.post('/add_admin_post', data);
};

export const pinPost = async (data) => {
    return await axiosClient.put(`/admin_pin_post`, data);
};

export const unpinPost = async (data) => {
    return await axiosClient.put(`/admin_unpin_post`, data);
};

export const editStatus = async (data) => {
    return await axiosClient.put(`/edit_course_status`, data);
};

export const getCourseAttendee = async (id) => {
    return await axiosClient.get(`/get_course_attendee/${id}`);
};

export const addRecommendedCourse = async (data) => {
    return await axiosClient.post(`/add_recomended_course`, data);
};

export const addRecommendedInstru = async (data) => {
    return await axiosClient.post(`/add_recomended_instructor`, data);
};

export const getRecommendedCourse = async () => {
    return await axiosClient.get(`/get_recomended_course`);
};

export const getRecInstructor = async () => {
    return await axiosClient.get(`/get_recomended_instructor`);
};

export const postActivity = async (data) => {
    return await axiosClient.post(`/edit_activity_user_post`, data);
};


/** Pre-College Course */

export const getCoursePreCollege = async () => {
    return await axiosClient.get('/pre_clg_course_all');
};

export const getCourseByIdPreCollege = async (id) => {
    return await axiosClient.get(`/pre_clg_course_by_id/${id}`);
};

export const addCoursePreCollege = async (data) => {
    return await axiosClient.post('/pre_clg_add_course', data);
};

export const editCoursePreCollege = async (data) => {
    return await axiosClient.put('/pre_clg_edit_course', data);
};

export const deleteCoursePreCollege = async (id) => {
    return await axiosClient.delete(`/pre_clg_delete_course/${id}`);
};

export const getCourseGroupDetailsPreCollege = async (id) => {
    return await axiosClient.get(`/pre_clg_get_course_group_details/${id}`);
};

export const editStatusPreCollege = async (data) => {
    return await axiosClient.put(`/pre_clg_edit_course_status`, data);
};

export const getPostsDetailPreCollege = async (id) => {
    return await axiosClient.get(`/pre_clg_get_admin_post/${id}`);
};

export const addPostPreCollege = async (data) => {
    return await axiosClient.post('/pre_clg_add_admin_post', data);
};

export const pinPostPreCollege = async (data) => {
    return await axiosClient.put(`/pre_clg_admin_pin_post`, data);
};

export const unpinPostPreCollege = async (data) => {
    return await axiosClient.put(`/pre_clg_admin_unpin_post`, data);
};

export const getCourseAttendeePreCollege = async (id) => {
    return await axiosClient.get(`/pre_clg_course_attendee/${id}`);
};

export const Pre_clg_extend_user_course = async (data) => {
    return await axiosClient.put(`/pre_clg_extend_user_course`, data);
};


export const discussionDeletePreCollege = async (id) => {
    return await axiosClient.delete(`/pre_clg_admin_delete_post/${id}`);
};

/** Career-Launch Course */

export const getCourseCareer = async () => {
    return await axiosClient.get('/cl_course_all');
};

export const getCourseByIdCareer = async (id) => {
    return await axiosClient.get(`/cl_course_by_id/${id}`);
};

export const addCourseCareer = async (data) => {
    return await axiosClient.post('/cl_add_course', data);
};

export const editCourseCareer = async (data) => {
    return await axiosClient.put('/cl_edit_course', data);
};

export const deleteCourseCareer = async (id) => {
    return await axiosClient.delete(`/cl_delete_course/${id}`);
};

export const editStatusCareer = async (data) => {
    return await axiosClient.put(`/cl_edit_course_status`, data);
};

export const getCourseAttendeeCareer = async (id) => {
    return await axiosClient.get(`/cl_course_attendee/${id}`);
};

export const getAllPreCollegeCourse = async (id) => {
    return await axiosClient.get(`/get_all_preclg_course`);
};


/** certificates */

export const getCertificatesCourse = async () => {
    return await axiosClient.get('/cert_course_all');
}; 

export const getCourseByIdCertificates = async (id) => {
    return await axiosClient.get(`/cert_course_by_id/${id}`);
};

export const addCertificatesCourse = async (data) => {
    return await axiosClient.post('/add_cert_course', data);
};

export const editCertificatesCours = async (data) => {
    return await axiosClient.put('/cert_edit_course', data);
};

export const editCertificatesStatus = async (data) => {
    return await axiosClient.put(`/cert_edit_course_status`, data);
};

export const deleteCertificatesCourse = async (id) => {
    return await axiosClient.delete(`/cert_delete_course/${id}`);
};

export const getCourseAttendeeCertificates = async (id) => {
    return await axiosClient.get(`/cert_course_attendee/${id}`);
};


export const addPostCertificates= async (data) => {
    return await axiosClient.post('/cert_add_admin_post', data);
};

export const getPostsDetailCertificates = async (id) => {
    return await axiosClient.get(`/cert_get_admin_post/${id}`);
};

export const pinPostCertificates = async (data) => {
    return await axiosClient.put(`/cert_admin_pin_post`, data);
};

export const unpinPostCertificates = async (data) => {
    return await axiosClient.put(`/cert_admin_unpin_post`, data);
};

export const getAppCertificates = async (id) => {
    return await axiosClient.get(`/getCertAllCourse`);
};
export const cert_extend_user_course = async (data) => {
    return await axiosClient.put(`/cert_extend_user_course`, data);
};

export const discussionDeleteCertCollege = async (id) => {
    return await axiosClient.delete(`/cert_admin_delete_post/${id}`);
};

// dl
export const getAppDl = async (id) => {
    return await axiosClient.get(`/get_all_dl_course`);
};

export const getDlCourse = async () => {
    return await axiosClient.get('/Dl_course_all');
};

export const addDlEvent = async (data) => {
    return await axiosClient.post('/dl_event', data);
};

export const getaddDlEvent = async (id) => {
    return await axiosClient.get(`/dl_event_edit/${id}`);
};

export const editDlProgramStatus = async (data) => {
    const {course_id ,status } = data
    return await axiosClient.put(`/edit_program_status`, {program_id:course_id, status:status });
};

export const deleteDlProgram = async (id) => {
    return await axiosClient.delete(`/delete_program/${id}`);
};

export const getDlProgram = async (id) => {
    return await axiosClient.get(`/dl_event_by_id/${id}`);
};
export const getProgram = async () => {
    return await axiosClient.get('/dl_program_all');
};

export const getEvent = async () => {
    return await axiosClient.get('/dl_event_all');
};

export const aaddDLevent = async (data) => {
    return await axiosClient.post('/add_event', data);
};

export const deleteDlevent = async (id) => {
    console.log("deleteDlevent",id)
    return await axiosClient.delete(`/delete_event/${id}`);
};

export const editDlEventStatus = async (data) => {
    const {course_id ,status } = data
    return await axiosClient.put(`/edit_event_status`, {event_id:course_id, status:status });
};

export const getDlEvent = async (id) => {
    return await axiosClient.get(`/dl_event_by_id/${id}`);
};

export const addEventEdit = async (data) => {
    return await axiosClient.put('/edit_event', data);
};

export const getProgramAttendeDl = async (id) => {
    return await axiosClient.get(`/dl_program_attendee/${id}`);
};